import { BinaryQuestionTemplate } from '@templates';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RoutesList } from '@cycle-hangars/routes/Routes';
import { useCycleStore } from '@cycle-hangars/store/store';
import { ZodError } from 'zod';
import { ErrorMessages } from '@types';
import { scrollTop, parseZodErrors, stringFieldSchema } from '@utils';
import { SELECT_OPTIONS_ERROR } from '@cycle-hangars/constants/errorMessages';

export const CycleHangarSecured = () => {
  const navigate = useNavigate();
  const { isSecured, updateIsSecured, cycleHangarIssue } = useCycleStore();
  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);
  const title = 'Is the cycle hangar secured?';
  const subText = 'For example, can the cycle hangar close or lock?';

  const options = [
    {
      id: 'Yes',
      name: 'Yes',
      labelText: 'Yes',
      isDefault: isSecured === 'Yes',
    },
    {
      id: 'No',
      name: 'No',
      labelText: 'No',
      isDefault: isSecured === 'No',
    },
    {
      id: 'NotSure',
      name: 'Not Sure',
      labelText: "I'm not sure",
      isDefault: isSecured === 'NotSure',
    },
  ];

  const handleChange = (selection: string) => {
    const updatedSelection = options.filter(
      (result) => result.labelText === selection,
    )[0].id;
    updateIsSecured(updatedSelection);
    setErrorMessages([]);
  };

  const buttonPrevious = {
    onClick: () => navigate(RoutesList.ISSUE_SELECTION),
  };

  const buttonNext = {
    onClick: () => {
      try {
        const validatedData = stringFieldSchema(
          'isSecured',
          SELECT_OPTIONS_ERROR.required.message,
        ).parse({
          isSecured,
        });
        if (validatedData.isSecured) {
          updateIsSecured(validatedData.isSecured);
        }
        switch (cycleHangarIssue) {
          case 'BrokenLock':
            navigate(RoutesList.CODE_MATCH);
            break;
          case 'BikeTheft':
            navigate(RoutesList.BIKE_THEFT);
            break;
          case 'DamagedOrVandalism':
            navigate(RoutesList.DAMAGED_OR_VANDALISED);
            break;
          default:
            return;
        }
        scrollTop();
      } catch (error) {
        const validationErrors = parseZodErrors(error as ZodError);
        setErrorMessages(
          validationErrors.map((error: ErrorMessages) => ({
            message: SELECT_OPTIONS_ERROR.required.message,
            path: error.path,
          })),
        );
      }
    },
  };

  return (
    <BinaryQuestionTemplate
      title={title}
      description={subText}
      options={options}
      errorPath={'isSecured'}
      errorMessages={errorMessages}
      onChange={handleChange}
      buttonNext={buttonNext}
      buttonPrevious={buttonPrevious}
    />
  );
};
